// extracted by mini-css-extract-plugin
module.exports = {"root":"WebhookLog_root__22NyA","title":"WebhookLog_title__3u6hY","status":"WebhookLog_status__2GTXo","failed":"WebhookLog_failed__2lKEs"};